module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kontakt"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.headline)
    }
  }), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "address"
  }, [_c('div', {
    staticClass: "contact-logo",
    domProps: {
      "innerHTML": _vm._s(_vm.body.address.logo)
    }
  }), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.body.address.street)
    }
  })]), _c('div', {
    staticClass: "contact"
  }, [_c('a', {
    attrs: {
      "href": "tel:" + _vm.body.contact.tel.raw
    }
  }, [_vm._v(_vm._s(_vm.body.contact.tel.nice))]), _c('br'), _c('a', {
    attrs: {
      "href": "mailto:" + _vm.body.contact.email
    }
  }, [_vm._v(_vm._s(_vm.body.contact.email))])]), _vm._m(0, false, false)]), _c('div', {
    staticClass: "clear"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "credits"
  }, [_c('p', {
    staticClass: "gold"
  }, [_vm._v("design & code by")]), _c('a', {
    attrs: {
      "href": "http://www.atelierkarasinski.com",
      "target": "blank"
    }
  }, [_vm._v("Atelier Karasinski")]), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.maxschulmeister.com",
      "target": "blank"
    }
  }, [_vm._v("Max Schulmeister")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c347c99c"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Kontakt.vue
// module id = 433
// module chunks = 1